import { Card, CardBody } from '@chakra-ui/react';
import React from 'react';

import { DeliverableContainerReceiptRecordGQLType } from '../../../../../../../../types/dashboard-core-gqlTypes.generated.d';
import { DeliverableReceiptsInputTable } from '~/core/routes/deliverables/[deliverableId]/final-output-report-versions/[receiptId]/DeliverableReceiptsInputTable';
import { Typography } from '~/packages/common-frontend/components/Typography';

export const DigitalMonthlyReportInputs = ({
  currentReceipt,
}: {
  currentReceipt: DeliverableContainerReceiptRecordGQLType;
}) => {
  return (
    <>
      <Typography variant="section-title">Inputs</Typography>
      <Card variant="outline" size="lg" w="100%">
        <CardBody>
          <DeliverableReceiptsInputTable currentReceipt={currentReceipt} />
        </CardBody>
      </Card>
    </>
  );
};
